'use client';

import { FC } from 'react';

import { useSegment } from '@telialt/utils/src/segment';

import { apiGetUniqueOfferDocument } from './api';
import { TriggerDownloadButton } from './components/TriggerDownloadButton';
import { TriggerDownloadLink } from './components/TriggerDownloadLink';
import { ContractSummaryButtonProps, UniqueOfferDocumentRequestParams } from './model';
import { useDownloadFileOrGiveDownloadLink } from './useDownloadFileOrGiveDownloadLink';

type Props = { params: UniqueOfferDocumentRequestParams } & ContractSummaryButtonProps;

export const DownloadUniqueOfferContractSummaryButton: FC<Props> = ({ className, params, isNegative }) => {
    const segment = useSegment();
    const { fileDownloadLink, isPending, download } = useDownloadFileOrGiveDownloadLink(
        async () => (await apiGetUniqueOfferDocument(segment, params)).data.fileUrl,
        ['unique-offer', segment, params],
    );

    if (fileDownloadLink) {
        return <TriggerDownloadLink href={fileDownloadLink} className={className} isNegative={isNegative} />;
    }

    return (
        <TriggerDownloadButton onClick={download} isLoading={isPending} className={className} isNegative={isNegative} />
    );
};
